__turbopack_context__.v({
  "card_outer": "styles-module-scss-module__8VEoIa__card_outer",
  "container": "styles-module-scss-module__8VEoIa__container",
  "properties_container": "styles-module-scss-module__8VEoIa__properties_container",
  "spinner": "styles-module-scss-module__8VEoIa__spinner",
  "tabs": "styles-module-scss-module__8VEoIa__tabs",
  "tabs_container": "styles-module-scss-module__8VEoIa__tabs_container",
  "zero_state": "styles-module-scss-module__8VEoIa__zero_state",
});
